
export class SortCriteria {

    public sortField: string = 'JobPosting.jobPublishDTTM';
    public sortOrderAsc: boolean = false;
}